import { VoxelScreen } from "./voxel";
import Camera from "./camera";
import Renderer from "./renderer";

import LUA_CODE from "./lua/main.lua"

async function init() {
  const voxel_screen = new VoxelScreen();
  await voxel_screen.init();

  const lua_runner_worker = new Worker(new URL('./lua_runner_worker.js', import.meta.url));
  lua_runner_worker.postMessage({ type: "init", data: { lua_code: LUA_CODE } });

  const renderer = new Renderer(voxel_screen);
  // await voxel_screen.setColormap({colormap: "pal0"})

  await renderer.init();
  // await voxel_screen.loadFromFile("models/bistro/exterior.obj.v");
  // await voxel_screen.loadFromFile("models/t_Interior_interior.obj.b");
  // await voxel_screen.loadFromFile("models/breakfast_room_breakfast_room.obj.b");
  // await voxel_screen.loadFromFile("models/holodeck_holodeck.obj.b");
  // await voxel_screen.loadFromFile("models/chair_chair_model.obj.b");
  // await voxel_screen.loadFromFile("models/breakfast_room.vox");
  // await voxel_screen.loadFromFile("models/breakfast_room.bin");
  // await voxel_screen.loadFromFile("models/bistro_exterior.bin");
  await voxel_screen.loadFromFile("models/mainscene.bin");
  // await voxel_screen.loadFromFile("models/test_nums_chunks.bin");
  // await voxel_screen.loadFromFile("models/3x3x3.bin");

  const camera = new Camera();

  window.addEventListener("resize", () => {
    renderer.resizeCanvas();
  });

  renderer.startRenderLoop(camera, lua_runner_worker);
}

init();
